import React from 'react';
import cl from './RefundPolicy.module.css';



const RefundPolicy = (props) => {
    return (
        <section className={cl.app_policy}>
          <h1>Politique de remboursement</h1>
           <h2>Annulation</h2>
           <p>Nous acceptons l'annulation de la commande avant que le produit ne soit expédié ou produit. Si la commande est annulée, vous serez intégralement remboursé.
                 Nous ne pouvons pas annuler la commande si le produit est déjà expédié.</p>

           <h2>Retours (le cas échéant)</h2>
           <p>Nous acceptons le retour des produits. Les clients ont le droit de demander un retour dans les 14 jours suivant la réception du produit.<br/>
                 Pour être admissible à un retour, votre article doit être inutilisé et dans le même état que vous l'avez reçu. Il faut aussi
                 être dans l'emballage d'origine. Pour compléter votre retour, nous avons besoin d'un reçu ou d'une preuve d'achat. Veuillez ne pas envoyer
                 votre achat au fabricant ou à notre station de transit.</p>
        </section>
    );
}

export default RefundPolicy;